import { useEffect } from 'react';
import { useMst } from '../models/rootModel';

interface useHandleSearchParamsPlanParams {
  isActive: boolean;
  nextStep: () => void;
  setInitialLoading: (il: boolean) => void;
}

export const useHandleSearchParamsPlan = async ({
  isActive,
  nextStep,
  setInitialLoading,
}: useHandleSearchParamsPlanParams) => {
  const { UserPayment, UserProgress } = useMst();

  // handle plan (for example: price_1NzJO0LHAdkZheN6kbwPssKA) in searchParams when exists
  useEffect(() => {
    if (!isActive || !UserPayment.stripePlans) {
      return;
    }
    // currentStep is for the case of voices-express only as it is the first step and we want it to move to next step(payment)
    // on the other hand we do want to allow back if someone is on web-quiz
    if (UserProgress.currentStep === 0 && UserPayment.getChoosenPlan() && UserPayment.hasPlanSearchParam) {
      nextStep();
      return;
    }

    setInitialLoading(false);
  }, [
    UserPayment,
    isActive,
    nextStep,
    UserPayment.stripePlans,
    UserProgress.currentStep,
    setInitialLoading,
    UserPayment.hasPlanSearchParam,
  ]);
};
